/* eslint-disable react/prop-types */
import styles from './quote.module.scss';

const Quote = ({quote, authorName, authorPosition}) => {

	return (
		<div className={styles.quote_container}>
			<div className={styles.quote}>
				{/* <img src={image} alt="logo colegio"/> */}
				<p className={styles.quote_description}>
					{quote}
				</p>
			</div>
			<hr/>
			<div className={styles.author}>
				<p className={styles.author_name}>
					{authorName}
				</p>
				<p className={styles.author_institution}>
					{authorPosition}
				</p>
			</div>
		</div>
	);
};

export default Quote;